import React from 'react'
import { cn } from './cn'

export function Input({ label, error, className, id, ...props }) {
  const inputId = id || props.name

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={inputId} className="mb-1.5 block text-sm font-medium text-secondary-700 dark:text-secondary-300">
          {label}
        </label>
      )}
      <input id={inputId} className={cn('input-field', error && 'border-red-500 focus:border-red-500 focus:ring-red-500/20', className)} {...props} />
      {error && <p className="mt-1 text-xs text-red-600 dark:text-red-400">{error}</p>}
    </div>
  )
}
